<template>
  <div>
    <!-- Dashboard Headline -->

    <!-- Page Content
        ================================================== -->
    <div class="">
      <div class="dashboard-headline">
        <h1>DP Jobs</h1>
      </div>
          <iframe
        :src="iframeUrl"
        frameborder="0"
        style="width: 100%; height: 800px;"
      ></iframe>
      </div>


    <!-- <div class="custom_spacer_emp_dashboard"></div> -->
    <!-- Spacer -->

    <!-- Spacer / End-->
    <!-- Row / End -->
  </div>

</template>

<script>
import { POST_API } from "../../store/actions.type";
import permission from "../../../../server/permission.js";


export default {
  
  data() {
    return {
      webUrl: process.env.VUE_APP_URL,
    webUrlV1Admin: process.env.VUE_APP_URL_V1_Admin + "/admin-login",
    iframeUrl: '',
      actions: "",
    };
  },
  

  methods: {
    
    
    permissionStaff() {
      if (this.$store.getters.getCurrentUserPermission) {
        if (
          this.$store.getters.getCurrentUserPermission.data.length > 0 &&
          this.$store.getters.currentUser.user_type_id == 2
        ) {
          var menu = this.$store.getters.getCurrentUserPermission.data;
          this.actions = permission.getPermissionStaff(menu, "DP Jobs Admin");
        }
      }
    },
    show(action) {
      if (this.$store.getters.currentUser.user_type_id == 2) {
        return this.actions.indexOf(action) >= 0 ? true : false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    $('.tip_img').hide();
    this.logged_in_user_id =
      this.$store.getters.currentUser != null ? this.$store.getters.currentUser.id : "";
    
    this.permissionStaff();
    this.iframeUrl = process.env.VUE_APP_URL_V1_Admin + "/admin-login"

    $(".dashboard-content-container .simplebar-scroll-content").animate(
      {
        scrollTop: 0,
      },
      "fast"
    );

  },
};
</script>
